import dynamic from "next/dynamic";
import Theme from "../../../components/Theme";
import WideCTA from "../../../components/organisms/common/WideCTA";
import People from "../../../components/organisms/common/People";
import FAQ from "../../../components/organisms/common/FAQ";
import HighlightFeaturesCards from "../../../components/organisms/common/HighlightFeaturesCards";
import CTA from "../../../components/organisms/common/CTA";
import FeaturesShowCaseCards from "../../../components/organisms/features/FeaturesShowCaseCards";
import SecondFold from "../../../components/organisms/features/SecondFold";
import FeaturedImage from "../../../components/organisms/features/FeaturedImage";
import Hero from "../../../components/organisms/common/Hero.js";
import Schema from "../../../components/organisms/common/Schema";
import CutoutFeaturedImage from "../../../components/organisms/common/CutoutFeaturedImage.js";
import AppStorage from "../../../components/AppStorage.js";
import TpWidget from "@components/atoms/document/TpWidget";
import { MenuShowCase } from "../../../components/organisms/common/MenuShowcase.js";
import { MenuShowCaseAccordion } from "@components/organisms/common/MenuShowCaseAccordion";
import PlanComparision from "@components/organisms/pricing/PlanComparision";
import PlanComparisionMobile from "@components/organisms/pricing/PlanComparision-Mobile";
const FeaturesGrid = dynamic(() =>
  import("../../../components/organisms/common/FeaturesGrid")
);
import {
  colors,
  font,
  lineHeight,
} from "../../../styles/cssinjs/helpers/variables.js";
export async function getStaticPaths({ locales }) {
  // Fetch All Path
  const res = await fetch(`${process.env.JSON_PATH}/routes.json`);
  const data = await res.json();

  // Specific Paths
  let routes = data.features.payments;

  // Variable for returning path
  let paths = [];

  // Create Paths with locales
  routes.forEach((path) => {
    for (const locale of locales) {
      paths.push({
        params: {
          page: path,
        },
        locale,
      });
    }
  });
  // return to getStaticProps()
  return {
    paths,
    fallback: false,
  };
}
export async function getStaticProps({ params, locale }) {
  let allData = {};

  // Fetch
  const headerResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/common/header.json`
  );
  const footerResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/common/footer.json`
  );
  const contentResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/features/payments/${params.page}.json`
  );

  // Catch Error
  if (contentResponse.status === 404) {
    return {
      notFound: true,
    };
  }

  // Convert
  allData.header = await headerResponse.json();
  allData.footer = await footerResponse.json();
  allData.content = await contentResponse.json();

  // Wrap
  const header = {
    header: allData.header,
  };
  const footer = {
    footer: allData.footer,
  };

  // Combine all data
  const data = await {
    ...header,
    ...footer,
    ...allData.content,
  };

  return {
    props: {
      data,
    },
  };
}
export const FeaturesGridSection = ({ data, isIconInline }) => {
  return (
    <section className="bg-light-blue-grey lg:pb-2">
      <FeaturesGrid
        data={data.list}
        colCount={data.colCount}
        isIconsInline={isIconInline}
      />
      <style>{`
        .card--default .icon-title-wrap figure {
          width: 24px;
        }
        .card--default.card--feature.has-three-col li p {
          padding-right: 0px !important;
        }
      `}</style>
    </section>
  );
};

export default function Appointments({ data, nonce }) {
  const seo = data.page_meta;
  const content = data.page_content;
  const helper = data.page_helper;
  const header = data.header;
  const footer = data.footer;

  return (
    <>
      <Theme
        header={header}
        footer={footer}
        className={`device--desktop features-faq pricing-layout ${helper.pageName}`}
        seo={seo}
        nonce={nonce}
      >
        <AppStorage pageName={`Features Sub Page - Payments`} />
        <Hero data={content.hero} />

        {content.hasOwnProperty("cutoutFeaturedImage") ? (
          <CutoutFeaturedImage
            data={content.cutoutFeaturedImage}
            imgClassName="lg:maxw-lg "
            className="lg:pb-20 md:pb-10 bg-light-blue-grey"
          />
        ) : (
          ""
        )}
        {content.hasOwnProperty("secondFold") ? (
          <SecondFold data={content.secondFold} />
        ) : (
          ""
        )}
        {content.hasOwnProperty("featuresGrid") ? (
          <FeaturesGridSection
            data={content.featuresGrid}
            isIconInline={true}
          />
        ) : (
          ""
        )}

        {helper.pageName === "featuresOnlinePayments-us" && (
          <>
            <MenuShowCase data={content.menuShowCase} />
            <MenuShowCaseAccordion data={content.menuShowCase} />
          </>
        )}

        {helper.pageName === "featuresOnlinePayments-us" && (
          <>
            <PlanComparision
              heading={content.pricingComparison.heading}
              categories={content.pricingComparison.categories}
              note={content.pricingComparison.note}
            />
            <PlanComparisionMobile
              heading={content.pricingComparison.heading}
              categories={content.pricingComparison.categories}
              isdiffHeading={content.pricingComparison.isdiffHeading}
              note={content.pricingComparison.note}
            />
          </>
        )}

        {content.hasOwnProperty("featuresShowcaseCards") ? (
          <section className={`bg-offset-top pb-10`}>
            <FeaturesShowCaseCards data={content.featuresShowcaseCards} />
            <p
              className="container feature-moreinfo"
              dangerouslySetInnerHTML={{
                __html: content.featuresShowcaseCardsUnderLine,
              }}
            ></p>
          </section>
        ) : (
          ""
        )}

        {content.hasOwnProperty("featuredImageSections") ? (
          <section className="container lg:pt-10 md:mb-10">
            <FeaturedImage data={content.featuredImageSections} />
          </section>
        ) : (
          ""
        )}

        {content.hasOwnProperty("cta") ? (
          <CTA data={content.cta} className="bg-offset-bottom" />
        ) : (
          ""
        )}

        {content.hasOwnProperty("paymentCta") ? (
          <CTA
            data={content.paymentCta}
            className="pos-rel bg-light-blue-grey md:pb-10 lg:pb-20 cta"
            ctaBgLightGreenColor={true}
          />
        ) : (
          ""
        )}
        {content.hasOwnProperty("getPaid") ? (
          <SecondFold data={content.getPaid} />
        ) : (
          ""
        )}
        {content.hasOwnProperty("highlightFeaturesCards") ? (
          <HighlightFeaturesCards data={content.highlightFeaturesCards} />
        ) : (
          ""
        )}

        {content.hasOwnProperty("faqs") ? (
          <FAQ
            className="lg:mb-15 md:mb-10 bg-offset-top"
            data={content.faqs}
          />
        ) : (
          ""
        )}

        {helper.pageName !== "featuresOnlinePayments-us" && <People />}
        {content.hasOwnProperty("wideCTA") ? (
          <WideCTA data={content.wideCTA} />
        ) : (
          ""
        )}

        <TpWidget />
        <style jsx global>
          {`
            .featuresOnlinePayments-us
              .pricing-wrap
              .card--default
              .p-block
              .header {
              font-weight: ${font.weight.bold};
            }
            .featuresOnlinePayments-us .pricing-wrap .card--default .p-block {
              margin-bottom: 32px !important;
            }
            .featuresOnlinePayments-us .highlight {
              background-color: ${colors.primitive.grey[600]} !important;
              padding-top: 0px !important;
            }
            .featuresOnlinePayments-us .card--default.card--feature {
              padding-bottom: 96px !important;
            }
            .featuresOnlinePayments-us
              .card--default
              ul:nth-of-type(9)
              p:nth-of-type(1) {
              margin-left: 6%;
            }
            .featuresOnlinePayments-us
              .card--default
              ul:nth-of-type(9)
              p:nth-of-type(2) {
              margin-left: 8%;
            }
            .featuresOnlinePayments-us
              .card--default
              ul:nth-of-type(9)
              p:nth-of-type(3) {
              margin-left: 10%;
            }
            .featuresOnlinePayments-us
              .card--default
              ul:nth-of-type(9)
              p:nth-of-type(4) {
              margin-left: 10%;
            }
            .featuresOnlinePayments-us .pr-features .card--default .p-block li {
              margin-left: 70px;
            }
            .featuresOnlinePayments-us
              .pr-features
              .card--default
              .p-block
              li:first-of-type {
              padding-left: 50px !important;
              margin-right: 24px !important;
            }
            .featuresOnlinePayments-us
              .pr-features
              .card--default
              .p-block
              li:nth-of-type(2) {
              padding-left: 50px !important;
              margin-right: 24px !important;
            }
            .featuresOnlinePayments-us
              .pr-features
              .card--default
              .p-block
              li:nth-of-type(3) {
              padding-left: 50px !important;
              margin-right: 12px !important;
            }
            .featuresOnlinePayments-us
              .pr-features
              .card--default
              .p-block
              li:nth-of-type(4) {
              padding-left: 50px !important;
              margin-right: 24px !important;
            }
            .featuresOnlinePayments-us .text-green {
              color: ${colors.primitive.green.light};
            }
            .featuresOnlinePayments-us .pr-features .card--default {
              max-width: 1160px !important;
            }
            .featuresOnlinePayments-us .pr-features .card--default {
              padding-bottom: 0px !important;
            }
            .featuresOnlinePayments-us .pr-features {
              background-color: #edf0f2 !important;
              max-width: 100%;
            }
            .featuresOnlinePayments-us .pricing-wrap {
              padding-bottom: 160px !important;
            }
            .featuresOnlinePayments-us .pricing-wrap .list-item small {
              font-size: ${font.size.sm[2]} !important;
              color: ${colors.primitive.grey[800]} !important;
            }
            .featuresOnlinePayments-us
              .cta-contrast.has-image.has-img-offset
              picture {
              bottom: -1px;
            }
            .featuresOnlinePayments-us .mobile-view .none.unavailable::before,
            .featuresOnlinePayments-us .pr-features .none.unavailable::before {
              content: "";
              display: inline-block;
              width: 20px;
              height: 20px;
              background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAVCAYAAABG1c6oAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADjSURBVHgB7ZGxCsIwEEAvre5+hYMIlk510z9QsK4Wqnv9Eh1dhHbUyT9w7dY6CI6Ojh0LIjEXWoklibhqHwTCXe6RuwOo+X1MVcL1g6Rr9/NzEp/E+NRfzjq2E7Z7zu6Sxnm1zgA1GaU0RIEowxjeD+E6kxU1VLb7A8ZNE46FlMe4jEDKckNVHQENIy9ooRQoWMVrLlP9DtG1zNsygISvxxQinQwxdcliZhv8GTs3CuCxRV2rixIhH2RvMyvbJ4R4++0qktVJW8bZiTJsEw8Xs1i56a+YzIMBimU5dxFYUPPHPAF4rm2bUtu1OwAAAABJRU5ErkJggg==)
                no-repeat;
              background-size: contain;
              position: relative;
              top: 0.25em;
              opacity: 0.5;
            }
            .featuresOnlinePayments-us .pr-features .none.unavailable {
              opacity: 1 !important;
            }
            .featuresOnlinePayments-us .pricing-wrap .list-item:last-child {
              display: none !important;
            }
            .featuresOnlinePayments-us .ticked-bulletin.list-item {
              background-color: #edf0f2 !important;
            }
            .featuresOnlinePayments-us .hero--default article {
              padding-right: 0px !important;
              max-width: 100% !important;
            }
            .featuresOnlinePayments-us .hero--default article .text-xl {
              font-size: ${font.size.lg[2.5]} !important;
              line-height: ${lineHeight[12]} !important;
            }
            .featuresOnlinePayments-us .use-setmore-wrap h2 {
              font-size: ${font.size.lg[1]} !important;
              line-height: ${lineHeight[10]} !important;
              margin-top: 80px !important;
            }
            .featuresOnlinePayments-us .grid--default.hero--default {
              padding-bottom: 120px !important;
            }
            .featuresOnlinePayments-us .grid--default.hero--default figure img {
              width: 640px !important;
              height: 420px !important;
            }
            .featuresOnlinePayments-us .use-setmore-wrap picture img {
              margin-top: -40px;
            }
            .featuresOnlinePayments-us .use-setmore-wrap > div {
              justify-content: space-evenly;
            }
            .featuresOnlinePayments-us .cta article {
              max-width: 460px !important;
            }
            .cta-light-green-theme .btn-quaternary {
              border: 1px solid ${colors.primitive.green[800]};
              color: ${colors.primitive.green[800]};
            }
            .cta-light-green-theme .cta-link {
              border-bottom: 1px solid ${colors.primitive.white.default};
            }
            .cta-light-green-theme .btn-ternary {
              background-color: ${colors.primitive.green[800]};
              color: ${colors.primitive.white.default};
            }
            .cta-light-green-theme .btn-ternary:hover {
              background-color: ${colors.primitive.green[900]};
            }
            .cta-light-green-theme .btn-quaternary:hover {
              background-color: ${colors.primitive.green[800]};
              color: ${colors.primitive.white.default};
            }
            .featuresOnlinePayments-us .text-brandcolor-v2 {
              color: ${colors.primitive.black[900]} !important;
              border-bottom: 1px solid ${colors.primitive.black[900]} !important;
            }
            .feature-moreinfo {
              margin-top: 30px;
              margin-bottom: 14px;
              font-size: ${font.size.sm[3]};
              line-height: ${lineHeight[7]};
              color: ${colors.primitive.black[500]};
            }
            .featuresOnlinePayments-us .features-faq .faq-section h2.text-xl {
              font-size: ${font.size.md[3]} !important;
              line-height: ${lineHeight[8]} !important;
            }

            .featuresOnlinePayments-us .highlight h2 {
              font-size: ${font.size.md[3]} !important;
              line-height: ${lineHeight[8]} !important;
            }

            .featuresOnlinePayments-us .faq-section.bg-offset-top::before {
              height: 100% !important;
              margin-bottom: 0px;
              padding-bottom: 120px;
              background-color: #edf0f2 !important;
            }
            @media (max-width: 1024px) {
              .featuresOnlinePayments-us
                .grid--default.hero--default
                figure
                img {
                width: 100% !important;
                margin-top: 0px;
              }
            }
            @media (max-width: 900px) {
              .featuresOnlinePayments-us
                .faq-section#seeplan-toggle
                .faq
                .active,
              .featuresOnlinePayments-us #seeplan-toggle .faq-section .faq {
                background-color: #fff !important;
              }
              .featuresOnlinePayments-us #seeplan-toggle faq label {
                padding-block: 20px;
              }
              .featuresOnlinePayments-us #seeplan-toggle {
                padding-inline: 20px !important;
                margin-inline: 0px !important;
                position: relative;
                background-color: ${colors.primitive.grey[600]};
                margin-bottom: 80px;
              }
              .featuresOnlinePayments-us .faq-section h2.text-xl {
                margin-bottom: 40px !important;
              }
              .featuresOnlinePayments-us #seeplan-toggle::after {
                display: block;
                content: "";
                width: 100%;
                height: 200px;
                background-color: ${colors.primitive.grey[600]};
                position: absolute;
                top: 0px;
                left: 0;
                z-index: -1;
              }
              .featuresOnlinePayments-us .grid--default.hero--default {
                padding-bottom: 80px !important;
              }
              .featuresOnlinePayments-us .use-setmore-wrap h2 {
                margin-top: 40px !important;
              }
              .featuresOnlinePayments-us .card--default.card--feature {
                padding-bottom: 80px;
              }
              .featuresOnlinePayments-us
                .grid--default.hero--default
                figure
                img {
                width: 108% !important;
                height: 100% !important;
                position: relative;
                left: -14px;
              }
              .featuresOnlinePayments-us
                .container.grid--default.hero--default {
                margin-right: 0;
                margin-left: 0;
              }
              .featuresOnlinePayments-us .grid--default.hero--default figure {
                overflow: hidden;
              }
              .featuresOnlinePayments-us
                .container.grid--default.hero--default
                article {
                margin-left: 20px !important;
                margin-right: 20px !important;
              }
            }
            @media (max-width: 780px) {
              .featuresOnlinePayments-us .mobile-view card--default .header {
                font-size: 12px !important;
                line-height: 20px !important;
              }
              .menushowcase h2 {
                text-align: left !important;
              }
              .featuresOnlinePayments-us .highlight h2 {
                margin-right: 0px !important;
              }
              .featuresOnlinePayments-us .highlight h2,
              .featuresOnlinePayments-us .use-setmore-wrap h2 {
                font-size: ${font.size.md[3]} !important;
                line-height: ${lineHeight[8]} !important;
              }
              .featuresOnlinePayments-us .hero--default article .text-xl {
                font-size: ${font.size.lg[1]} !important;
                line-height: ${lineHeight[11]} !important;
              }
              .featuresOnlinePayments-us .mobile-view ul:nth-of-type(8) strong,
              .featuresOnlinePayments-us .mobile-view ul:nth-of-type(8) a,
              .featuresOnlinePayments-us .mobile-view ul:nth-of-type(8) p span {
                font-size: 7px !important;
                line-height: 12px !important;
              }
              .featuresOnlinePayments-us .p-block .faq-ques::after {
                position: relative !important;
                background-repeat: no-repeat;
                top: 15px;
                right: -25px;
              }
              .faq-section#seeplan-toggle {
                margin-top: -10px !important;
              }
              .faq-section#seeplan-toggle .faq #show::after {
                top: -2px;
                transform: rotate(360deg);
              }
              .featuresOnlinePayments-us
                .mobile-view
                .card--default
                .list-item
                li {
                margin-bottom: 20px !important;
              }
              .featuresOnlinePayments-us
                .mobile-view
                .card--default
                .list-item
                li,
              .featuresOnlinePayments-us
                .mobile-view
                .card--default
                .list-item
                p,
              .featuresOnlinePayments-us
                .mobile-view
                .card--default
                .list-item
                span {
                width: 100% !important;
              }
              .featuresOnlinePayments-us
                .mobile-view
                .card--default
                .sub-header {
                margin-bottom: 16px !important;
              }
              .featuresOnlinePayments-us .card--default .sub-header small {
                font-size: ${font.size.sm[1]} !important;
                line-height: ${lineHeight[4]} !important;
                color: ${colors.primitive.grey[800]} !important;
              }
              .featuresOnlinePayments-us .faq-section.bg-offset-top::before {
                padding-bottom: 80px;
              }
              .share-options-content ul {
                padding-left: 20px;
              }
            }
            @media (max-width: 761px) {
              .featuresOnlinePayments-us .mobile-view .card--default .header {
                font-size: 12px !important;
                line-height: 20px !important;
              }
              .featuresOnlinePayments-us .pricing-wrap {
                padding-bottom: 80px !important;
              }
            }
          `}
        </style>
      </Theme>
      {content.hasOwnProperty("faqs") ? (
        <Schema data={content.faqs.list} />
      ) : (
        ""
      )}
    </>
  );
}
